import "core-js/actual/promise/with-resolvers";
import React from "react";
import { createRoot } from "react-dom/client";
import { pdfjs } from "react-pdf";
import "@formatjs/intl-getcanonicallocales/polyfill";
import "@formatjs/intl-locale/polyfill";
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/locale-data/en";
import "@formatjs/intl-numberformat";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";

import App from "./app";
import "normalize.css";
import "./style.scss";

pdfjs.GlobalWorkerOptions.workerSrc = "/assets/pdf/pdf.worker.min.js";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);

root.render(<App />);
